module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tagsCom"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("tag cloud")]), _vm._v(" "), _c('div', {
    staticClass: "sep"
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index <= 15 || _vm.isMore),
        expression: "index <= 15 || isMore"
      }],
      key: index,
      class: {
        active: _vm.nowTagName === item
      },
      on: {
        "click": function($event) {
          return _vm.chooseTag(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(item))])])
  }), 0), _vm._v(" "), (_vm.tags.length > 15 && !_vm.isMore) ? _c('div', {
    staticClass: "more",
    on: {
      "click": _vm.getMore
    }
  }, [_c('span', [_vm._v("查看更多")]), _vm._v(" "), _c('i', [_vm._v(">")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e6418a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/blogTags/blogTags.vue
// module id = 268
// module chunks = 1